import { PaymentGatewaysTable } from '@/components/features/payment-gateways'

export const PaymentGateways = () => {
    return <PaymentGatewaysTable />
}
